import { render, staticRenderFns } from "./banner-swiper.vue?vue&type=template&id=7da18197&"
import script from "./banner-swiper.vue?vue&type=script&lang=js&"
export * from "./banner-swiper.vue?vue&type=script&lang=js&"
import style0 from "../styles/banner-swiper.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports